import React, { Component } from "react";
import {
  Container,
  Button,
  ModalFooter,
  ModalBody
} from "reactstrap";


export default class Confirm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Container fluid style={{ padding: 0, margin: 0, alignItems: "center" }}>
        <ModalBody>
          <h5 style={{ margin: 10 }}> Item is not available?</h5>
        </ModalBody>
        <ModalFooter>
          <div>
            <Button
              color="success"
              onClick={() => {
                this.props.toggleFullFilled();
                this.props.goBack();
              }}
            >
              Confirm
            </Button>{" "}
            <Button
              color="danger"
              style={{paddingLeft:25,paddingRight:25}}
              onClick={() => {
                this.props.goBack();
              }}
            >
              No
            </Button>
          </div>
        </ModalFooter>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DetailedOrderCard/Confirm.js